<script>
	import { onMount, tick } from 'svelte';
	import HUD from '../components/HUD.svelte';
	import CommonDataManager from '../controllers/CommonDataManager.js';
	import { _, setLocale, localeForDevice } from '../localization';

	const commonData = CommonDataManager.getInstance();

	function localeLoaded(){
		commonData.setLandingLoaded(true);
	}

	onMount(async () => {
		commonData.setLoadedLocaleHandler(localeLoaded);
		setLocale(localeForDevice());
  });


</script>

<style>
	.loading_indicator_wrapper{
		margin: 0 auto;
		height: 80px;
		width: 80px;
		position: absolute;
		top: 50%;
    left: 50%;
    transform: translateY(-100%) translateX(-50%);
	}
	main{
		height: 100vh;
		width: 100%;
		position: relative;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		margin: 0;
	}
	.loading_view_wrapper{
		flex: 1;
		width: 100%;
	}
</style>

<main>
	<div class="loading_view_wrapper">
		<div class="loading_indicator_wrapper">
			<HUD/>
		</div>
	</div>
</main>
